import { logout, saveSession } from '@/actions/auth';
import { Nullable } from '@/types';
import { create /*s, StateCreator*/ } from 'zustand';
import {
  createJSONStorage,
  persist /*, PersistOptions*/,
  devtools,
} from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type AuthStore = {
  accessToken: Nullable<string>;
  refreshToken: Nullable<string>;
  emailNotYetVerify: Nullable<string>;
  setAccessToken: (token: Nullable<string>) => void;
  setRefreshToken: (tokenFreresh: string) => void;
  setEmailNotYetVerify: (emailNotYetVerify: Nullable<string>) => void;
};

// type MyPersist = (
//   config: StateCreator<AuthStore>,
//   options: PersistOptions<AuthStore>,
// ) => StateCreator<AuthStore>;

export const useAuthStore = create<AuthStore>()(
  immer(
    devtools(
      // persist(
      (set, get): AuthStore => ({
        accessToken: '',
        refreshToken: '',
        emailNotYetVerify: '',
        setAccessToken: (token: Nullable<string>) => {
          // if (token) {
          //   saveSession(token);
          // } else {
          //   logout();
          // }
          set(state => ({ accessToken: token }));
        },
        setRefreshToken: (tokenFreresh: Nullable<string>) =>
          set(state => ({ refreshToken: tokenFreresh })),
        setEmailNotYetVerify: (emailNotYetVerify: Nullable<string>) =>
          set(state => ({ emailNotYetVerify })),
      }),
      // {
      //   name: 'auth-storage',
      //   storage: createJSONStorage(() => localStorage),
      //   partialize: state =>
      //     Object.fromEntries(
      //       Object.entries(state).filter(
      //         ([key]) => !['setAccessToken', 'setRefreshToken'].includes(key),
      //       ),
      //     ),
      // },
      // ),
    ),
  ),
);
